module.exports = __webpack_public_path__ + "static/media/Woonboot@ax.70b54d86.jpg";